'use strict'

import ErrorPage from '@/components/ErrorPage.vue'

export default [
  {
    path: '/404',
    name: '404',
    component: ErrorPage,
    meta: {layout: 'error'}
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/error.js